type TrackingEvent = {
  name?: string;
  id: string;
  sourceUrl?: string;
};

type CookiebotWindow = Window & {
  Cookiebot?: {
    consent?: {
      statistics?: boolean;
    };
  };
};

const EMPTY_TRACKING_EVENT: TrackingEvent = {
  name: '',
  id: '',
  sourceUrl: '',
};

export const hasCookiebotStatisticsConsent = () => {
  if (typeof window === 'undefined') return false;

  const cookiebotWindow = window as CookiebotWindow;
  const statisticsConsent = cookiebotWindow.Cookiebot?.consent?.statistics;

  if (typeof statisticsConsent !== 'boolean') return false;

  return statisticsConsent;
};

const toConsentAwareTrackingEvent = <T extends TrackingEvent>(event: T): T => {
  if (hasCookiebotStatisticsConsent()) {
    return event;
  }

  return EMPTY_TRACKING_EVENT as T;
};

export default toConsentAwareTrackingEvent;
